import { PlaybooksIcon } from '@playbooks/assets/brand';

const AuthBrand = ({ title, description }) => {
	// Render
	return (
		<div className='flex-column items-center gap-2 text-center'>
			<PlaybooksIcon className='mb-2 size-10 rounded-panel' aria-hidden />
			<h1 className='type-section-title'>{title}</h1>
			<p className='type-body text-foreground-body'>{description}</p>
		</div>
	);
};

export { AuthBrand };
